<template>
  <div class="news-wrapper">
    <InfoList
      :data="newsList"
      :visited="visitedNews"
      :props="{ time: 'pubDate' }"
      :busy="busy"
      @load="getNewsList"
      @to="goPage"
    />
    <LoadMoreButton :finished="finished" :loading="loading" @click="getNewsList" />
  </div>
</template>

<script>
import InfoList from '@/components/common/info/InfoList.vue'
import LoadMoreButton from '@/components/common/LoadMoreButton.vue'

const DATE_RANGE = 10
export default {
  name: 'NewsList',
  components: { InfoList, LoadMoreButton },
  data() {
    return {
      newsList: [],
      cacheNewsList: [],
      visitedNews: [],
      loading: false,
      finished: false,
      pageNum: 0,
      startTime: this.$dayjs().subtract(DATE_RANGE, 'day').format('YYYY-MM-DD'),
      endTime: this.$dayjs().format('YYYY-MM-DD'),
      deactivated: false
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    busy() {
      return this.loading || this.finished || this.deactivated
    }
  },
  mounted() {
    this.initVisited()
  },
  activated() {
    this.deactivated = false
  },
  deactivated() {
    this.deactivated = true
  },
  methods: {
    async getNewsList() {
      if (this.busy) return

      this.loading = true

      // f10新闻列表一次加载20条
      while (this.cacheNewsList.length < 20) {
        this.pageNum++

        const res = await this.$post(this.$api.rm.news + '/news/list', {
          startTime: this.startTime,
          endTime: this.endTime,
          pageNum: this.pageNum,
          pageSize: 20,
          source: '',
          symbols: [this.symbol],
          types: []
        })

        const list = res.data?.list ?? []
        const isLastPage = res.data?.isLastPage ?? true

        // 全部存入cache
        this.cacheNewsList.push(...list)

        // 没有新闻
        if (!list.length) {
          this.finished = true
          break
        }

        // 当前区间没有新闻
        if (isLastPage) {
          this.pageNum = 0
          this.startTime = this.$dayjs(this.startTime)
            .subtract(DATE_RANGE + 1, 'day')
            .format('YYYY-MM-DD')
          this.endTime = this.$dayjs(this.endTime)
            .subtract(DATE_RANGE + 1, 'day')
            .format('YYYY-MM-DD')
        }
      }

      // 从cache中更新到展示列表
      this.newsList.push(...this.cacheNewsList.slice(0, 20))
      this.cacheNewsList = this.cacheNewsList.slice(this.cacheNewsList.length - 20)

      this.loading = false
    },
    goPage(item) {
      this.saveVisited(item.id)
      this.$router.push({
        path: '/news/details',
        query: { id: item.id, symbol: this.$route.query.symbol }
      })
    },
    initVisited() {
      const list = JSON.parse(localStorage.getItem('news_visited') ?? '[]')
      // 避免数量无限增大
      if (list.length > 100) list.length = 100
      this.visitedNews = list
    },
    saveVisited(id) {
      this.visitedNews.unshift(id)
      localStorage.setItem('news_visited', JSON.stringify([...new Set(this.visitedNews)]))
    }
  }
}
</script>

<style lang="scss" scoped>
.news-wrapper {
  background: var(--bg-color-2);
}
</style>
